import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundtomahabaleshwarbusonrent() {



  const cardData =
  {
    keyword: 'Daund to Mahabaleshwar Bus On Rent',
    heading: 'Sanavi Travels: Daund to Mahabaleshwar Bus On Rent',
    headingDescription: 'Sanavi Travels offers reliable Daund to Mahabaleshwar Bus On Rent, providing safe, comfortable, and spacious transportation for families, groups, corporate trips, and tourists traveling from Daund to the scenic hill station of Mahabaleshwar. Our fleet of well-maintained AC and non-AC buses ensures smooth rides, ample seating, and sufficient luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient pickup and drop services across Daund, Pune, and nearby areas, making it ideal for local travel, outstation trips, corporate outings, school excursions, and group tours. Choose Sanavi Travels for trusted Daund to Mahabaleshwar bus rental services, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Mahabaleshwar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Venna Lake",
    "description": "Venna Lake is a popular tourist spot in Mahabaleshwar, offering boating facilities and scenic views of surrounding hills. The lake is ideal for picnics, family outings, and enjoying tranquil sunsets amidst natural beauty."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is famous for its strawberry farms, fresh fruit products, and delightful eateries. Visitors can enjoy strawberry-based dishes, jams, and local treats while exploring the beautifully landscaped gardens."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort, located near Mahabaleshwar, is a historic fort where the legendary battle between Chhatrapati Shivaji Maharaj and Afzal Khan took place. The fort offers panoramic views, trekking opportunities, and rich historical significance."
  },
  {
    "title": "Arthur’s Seat",
    "description": "Arthur’s Seat is a breathtaking viewpoint in Mahabaleshwar, offering panoramic views of the Krishna Valley and surrounding hills. It is popular among tourists for photography, sunrise and sunset views, and nature walks."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a scenic cliff that resembles an elephant’s head. Visitors enjoy the stunning views, cool breezes, and peaceful environment, making it a favorite spot for nature lovers."
  },
  {
    "title": "Wilson Point (Sunrise Point)",
    "description": "Wilson Point is the highest point in Mahabaleshwar, known for spectacular sunrise views. It is a must-visit for early morning walkers and photography enthusiasts."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is a picturesque waterfall surrounded by lush greenery. The waterfall is especially impressive during the monsoon season, attracting nature lovers and photographers."
  },
  {
    "title": "Kate’s Point",
    "description": "Kate’s Point provides panoramic views of the Krishna Valley and Dhom Dam. It is a popular viewpoint for tourists seeking scenic beauty and peaceful surroundings."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a natural rock formation offering panoramic views of valleys and the Savitri River. The viewpoint is named for its resemblance to an elephant’s head."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "Mahabaleshwar Temple is an ancient Hindu temple dedicated to Lord Shiva. It holds cultural and religious significance for locals and pilgrims, offering a glimpse into the region’s spiritual heritage."
  }
]
,



"services": [
  {
    "name": "Daund to Mahabaleshwar Bus On Rentals",
    "description": "Daund to Mahabaleshwar Bus On Rentals provides comfortable, safe, and reliable transport for travelers heading to the scenic hill station of Mahabaleshwar. With well-maintained air-conditioned buses, spacious seating, luggage space, and professional chauffeurs, the service is perfect for family trips, group outings, corporate retreats, school excursions, and weekend getaways. Emphasizing punctuality, comfort, and convenience, it ensures a smooth journey through the Western Ghats while offering a relaxing travel experience for all passengers."
  },
  {
    "name": "Mahabaleshwar Bus from Daund",
    "description": "Mahabaleshwar Bus from Daund offers flexible and efficient bus services for groups traveling to Mahabaleshwar. Equipped with AC interiors, comfortable seating, and skilled drivers, it guarantees a safe and enjoyable long-distance journey. Ideal for tourist groups, families, corporate travelers, and friends seeking a hassle-free travel experience to the hill station."
  },
  {
    "name": "AC Bus Daund to Mahabaleshwar",
    "description": "AC Bus Daund to Mahabaleshwar ensures a cool and comfortable journey for long-distance travelers. With air-conditioned interiors, spacious seating, and professional chauffeurs, the service provides an ideal solution for families, corporate teams, and group travelers who want to enjoy a stress-free, smooth, and comfortable ride to Mahabaleshwar."
  },
  {
    "name": "Luxury Bus Mahabaleshwar",
    "description": "Luxury Bus Mahabaleshwar delivers a premium travel experience with plush seating, spacious interiors, and professional drivers. Perfect for VIP travel, family vacations, corporate retreats, and special trips, this service ensures comfort, style, punctuality, and a memorable journey through the scenic routes of Mahabaleshwar."
  },
  {
    "name": "Family Bus Mahabaleshwar",
    "description": "Family Bus Mahabaleshwar is designed for safe and enjoyable family trips to the hill station. With AC buses, ample seating, luggage storage, and experienced chauffeurs, it provides a stress-free and convenient travel option. Families can relax and enjoy the picturesque drive while ensuring everyone’s comfort and safety."
  },
  {
    "name": "Group Travel Bus Mahabaleshwar",
    "description": "Group Travel Bus Mahabaleshwar caters to friends, corporate teams, school groups, or other large gatherings planning a trip to Mahabaleshwar. With AC interiors, comfortable seating, and professional drivers, it ensures organized, safe, and hassle-free group travel. This service is perfect for sightseeing, weekend getaways, and hill station tours."
  },
  {
    "name": "Affordable Bus Mahabaleshwar",
    "description": "Affordable Bus Mahabaleshwar provides budget-friendly travel solutions without compromising on comfort or safety. Suitable for families, student groups, corporate travelers, or friends, it offers spacious AC buses, skilled chauffeurs, and reliable service for a smooth journey to Mahabaleshwar."
  },
  {
    "name": "Chauffeur Driven Bus Mahabaleshwar",
    "description": "Chauffeur Driven Bus Mahabaleshwar offers a stress-free travel experience with professional drivers handling navigation, traffic, and passenger safety. Perfect for corporate outings, family trips, and group excursions, this service ensures a safe, comfortable, and enjoyable ride to the hill station."
  },
  {
    "name": "Best Bus Daund to Mahabaleshwar",
    "description": "Best Bus Daund to Mahabaleshwar focuses on providing top-quality bus services for long-distance travel. With AC interiors, spacious seating, skilled drivers, and well-maintained buses, it guarantees a safe, punctual, and comfortable journey suitable for weddings, corporate trips, school tours, and leisure travel to Mahabaleshwar."
  },
  {
    "name": "Tourist Bus Mahabaleshwar",
    "description": "Tourist Bus Mahabaleshwar is designed for travelers seeking sightseeing and leisure tours in Mahabaleshwar. Equipped with comfortable AC seating, luggage space, and professional chauffeurs, it ensures an enjoyable journey while exploring the hill station and nearby attractions."
  },
  {
    "name": "Hill Station Bus Tour",
    "description": "Hill Station Bus Tour offers specialized transport for trips to Mahabaleshwar and other nearby hill stations. With air-conditioned interiors, spacious seating, and experienced drivers, it provides a safe, comfortable, and scenic travel experience for families, friends, and corporate groups."
  },
  {
    "name": "Weekend Trip Bus",
    "description": "Weekend Trip Bus provides convenient and comfortable bus services for short trips and weekend getaways to Mahabaleshwar. Ideal for friends, families, and office groups, it ensures smooth travel, punctual arrivals, and an enjoyable journey through scenic routes."
  },
  {
    "name": "Online Bus Booking Daund",
    "description": "Online Bus Booking Daund allows travelers to easily reserve buses for Daund to Mahabaleshwar trips through a simple online platform. With instant confirmation, flexible scheduling, and hassle-free management, it ensures smooth travel planning for families, corporate groups, and tourist parties."
  },
  {
    "name": "Daund Travel Bus",
    "description": "Daund Travel Bus provides reliable and safe transportation for long-distance journeys from Daund to Mahabaleshwar. With well-maintained AC buses, spacious seating, and professional chauffeurs, it ensures a comfortable and punctual ride for families, tourists, school trips, and corporate groups."
  },
  {
    "name": "Mahabaleshwar Tour Bus",
    "description": "Mahabaleshwar Tour Bus offers specialized services for sightseeing and leisure tours in Mahabaleshwar. With AC interiors, comfortable seating, and experienced drivers, it ensures travelers enjoy scenic views, convenient travel, and a memorable hill station experience."
  }
],
"tableData": [
  ["Daund to Mahabaleshwar Bus On Rentals", "Mahabaleshwar Bus from Daund"],
  ["AC Bus Daund to Mahabaleshwar", "Luxury Bus Mahabaleshwar"],
  ["Family Bus Mahabaleshwar", "Group Travel Bus Mahabaleshwar"],
  ["Affordable Bus Mahabaleshwar", "Chauffeur Driven Bus Mahabaleshwar"],
  ["Best Bus Daund to Mahabaleshwar", "Tourist Bus Mahabaleshwar"],
  ["Hill Station Bus Tour", "Weekend Trip Bus"],
  ["Online Bus Booking Daund", "Daund Travel Bus"],
  ["Mahabaleshwar Tour Bus", "—"]
]
,




"whychoose": [
  {
    "WhyChooseheading": "Daund to Mahabaleshwar Bus On Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and reliable bus rental services from Daund to Mahabaleshwar, perfect for family trips, group tours, corporate outings, and scenic hill station journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Buses",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and regularly serviced buses that ensure a smooth and enjoyable journey from Daund to Mahabaleshwar."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with the Daund to Mahabaleshwar route, ensuring safe and timely travel for your trip."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Daund to Mahabaleshwar bus rentals, inclusive of fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, route updates, and itinerary planning for your Daund to Mahabaleshwar trip."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from one‑way, round‑trip, or customized bus rental packages based on your Daund to Mahabaleshwar travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Daund to Mahabaleshwar bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services from Daund to Mahabaleshwar?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable bus rentals from Daund to Mahabaleshwar for scenic and leisure travel.'
  },
  {
    question: 'How can I book a bus from Daund to Mahabaleshwar?',
    answer: 'You can easily book through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for the Daund to Mahabaleshwar route?',
    answer: 'Sanavi Travels provides air‑conditioned and well‑maintained buses suitable for long‑distance and hill station travel.'
  },
  {
    question: 'Are drivers experienced on the Daund to Mahabaleshwar route?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with the entire route from Daund to Mahabaleshwar.'
  },
  {
    question: 'Can I customize my Daund to Mahabaleshwar bus trip?',
    answer: 'Absolutely. You can select preferred stops, routes, and travel timings based on your trip preferences.'
  },
  {
    question: 'Is the bus rental service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock support and assistance throughout your Daund to Mahabaleshwar bus journey.'
  },
  {
    question: 'Are the buses sanitized before departure?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey to ensure safety and comfort.'
  },
  {
    question: 'What payment options are available for booking?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Daund to Mahabaleshwar bus trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajay More',
    feedback: 'Booked a bus from Daund to Mahabaleshwar. Comfortable ride, scenic views, and excellent service throughout the journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Great experience with the Daund to Mahabaleshwar bus rental. Clean bus and punctual service made our hill station trip memorable.',
    rating: 5
  }
];




























































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund to Mahabaleshwar Bus On Rentals - Sanavi Travels",
  "description": "Sanavi Travels offers Daund to Mahabaleshwar bus rentals for family trips, group travel, weekend getaways, and hill station tours. AC and luxury chauffeur-driven buses available with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "92"
  }
};





  return (
    <div>


<Helmet>
  <title>
    Daund to Mahabaleshwar Bus On Rentals | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Daund to Mahabaleshwar bus from Sanavi Travels for family trips, group travel, weekend getaways, and hill station tours. AC and luxury chauffeur-driven buses available. Online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/112.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundtomahabaleshwarbusonrent;